import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const CardWrapper = styled.div`
  border-radius: 20px;
  border: 4px solid var(--dui-color-yellow-500);
  background: var(--dui-color-white);
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  font-family: inherit;
  margin: 25px 30px;
  @media screen and (max-width: ${breakpoints.desktop}) {
    margin: 0 8px 38px 8px;
  }
`;

export const Banner = styled.div`
  background: var(--dui-color-yellow-500);
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: ${breakpoints.desktop}) {
    padding: 16px;
    & dhl-icon {
      width: 29px;
    }
  }
`;

export const BannerIcon = styled.span`
  font-size: 28px;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 24px;
  gap: 32px;
  @media screen and (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    padding: 16px;
  }
`;

export const CardInfo = styled.div`
  background: var(--dui-color-black-opacity-05);
  border-radius: 24px;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 36px;
  @media screen and (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }
`;

export const InfoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const SetupInfo = styled.div`
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 8px;
`;

export const Note = styled.div`
  font-size: 12px;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  justify-content: space-between;
  font-size: var(--dui-size-font-xs);
`;
export const NormalPriceRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--dui-size-space-2x);
  font-size: var(--dui-size-font-xs);
  margin-top: 8px;
`;

export const PriceRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: anchor-center;
`;

export const PriceLabel = styled.span`
  background: ${({ variant }) =>
    variant === "red" ? "transparent" : "var(--dui-color-yellow-500)"};
  color: ${({ variant }) =>
    variant === "red"
      ? "var(--dui-colors-action-foreground-secondary-default)"
      : "var(--dui-color-black)"};
  font-weight: bold;
  border-radius: var(--dui-size-space-4x);
  border: ${({ variant }) =>
    variant === "red"
      ? "2px solid var(--dui-colors-action-foreground-secondary-default)"
      : "none"};
  padding: 4px 12px;
  font-size: 12px;
  max-height: 24px;
  min-width: fit-content;
`;

export const NormalPrice = styled.div`
  color: var(--dui-color-gray-500);
  font-size: 16px;
  text-decoration: line-through;
  font-weight: bold;
  margin: 0 7px;
`;

export const OpenAccountButton = styled.a`
  border: 1px solid var(--dui-colors-action-foreground-secondary-default);
  color: var(--dui-colors-action-foreground-secondary-default);
  border-radius: var(--dui-size-radius-md);
  padding: var(--gaq-size-space-9px) var(--gaq-size-space-5px)
  cursor: pointer;
  text-align: center;
  textDecoration: none;
  padding: var(--dui-size-space-4x) var(--dui-size-space-8x);
  text-decoration: none;
  font-weight: 700;
  font-size: var(--dui-size-font-sm);
  &:focus {
    border: 2px solid var(--dui-colors-action-foreground-secondary-default);
  }
`;
